<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isInnovation="true" :selectedQidSmall="selectedQidSmall"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '练习1',
        small: [
          {
            id: 1,
            title: '(1)',
            desc: ['1.自行车又被称为：', '本题正确答案为AC，使用鼠标左键点击选项前的框来选定，选择后请点击下一题按钮。'],
            durationTime: 100,
            steer: [
              {
                id: '1-1',
                buttonStyle: {
                  width: '95%'
                },
                middenText: {
                  style: {
                    width: '45%',
                    top: '15%',
                    left: '27.5%',
                    bg: require('@/assets/exam/bj_yindao_zi.png')
                  },
                  value: [
                    { text: '同学，你好！' },
                    { text: '以下是正式测评开始前的练习，请你通过练习熟悉正式测评中将要用到的电脑操作。' },
                    { text: '练习由一些简单的问题组成，老师不会对你的作答判分，就是说无论你如何作答都不会影响你的正式测评结果。请认真熟悉每一种计算机操作，如果有问题，随时举手询问。' }
                  ]
                }
              },
              {
                id: '1-2',
                leftModelSteer: true,
                leftbg: require('@/assets/exam/kuang_up_right_chang.png'),
                buttonStyle: {
                  width: '65%',
                  float: 'right',
                  algin: 'center'
                },
                leftText: {
                  style: {
                    top: '35%',
                    left: '45%',
                    width: '50%',
                    algin: 'left'
                  },
                  value: [
                    { text: '一、请使用鼠标左键点击“资料一”-- 资料已经展开 –请答题。 ' }
                  ]
                },
                bg: [
                  // {
                  //   img: require('@/assets/exam/kuang_up_right_chang.png'),
                  //   style: {
                  //     top: '23%',
                  //     left: '7.2%',
                  //     width: '45%',
                  //     height: '480px'
                  //     // height: '50%'
                  //   }
                  // }
                ],
              },
              {
                id: '1-3',
                titleModelSteer: true,
                rightModelSteer: true,
                rightbg: require('@/assets/exam/kuang_up_left_chang.png'),
                buttonStyle: {
                  top: '-5%',
                  width: '50%',
                  float: 'left',
                  algin: 'right'
                },
                leftText: {
                  style: {
                    top: '400px',
                    left: '5%',
                    width: '50%',
                    algin: 'right'
                  },
                  value: [
                    { text: '二、本题正确答案为AC，使用鼠标左键点击选项前的框来选定' }
                  ]
                },
                bg: [
                  // {
                  //   img: require('@/assets/exam/kuang_up_right_chang.png'),
                  //   style: {
                  //     top: '17%',
                  //     left: '54.5%',
                  //     width: '45.5%',
                  //     // height: '210px'
                  //   }
                  // }
                ],
              }
            ],
            stemContent: [
              {
                type: 'text',
                value: '这个练习是让你熟悉“翻看资料”和“选择正确答案”的操作。'
              },
              {
                type: 'text',
                value: '请使用鼠标左键点击“资料一”-- 资料已经展开 – 请答题。'
              },
              {
                type: 'textArray',
                label: '资料一',
                value: [
                  { text: '自行车，又称脚踏车或单车，通常是二轮的小型陆上车辆。人骑上车后，以脚踩踏板为动力，是绿色环保的交通工具。英文bicycle。其中bi意指二，而cycle意指轮，即两轮车。在中国内地、台湾、新加坡，通常称其为“自行车”或“脚踏车”；在港澳则通常称其为“单车”（其实粤语通常都这么称呼）；而在日本称为“自転（转）车”。自行车种类很多，有单人自行车，双人自行车还有多人自行车。' },
                  { text: '截至2019年，我国自行车社会保有量已近4亿辆、电动自行车近3亿辆，均位居世界第一。' },
                  { text: '[摘编自：我国自行车社会保有量稳居世界第一 已近4亿辆.新浪财经（转自新华社）]', type: 'noTextIndent' }
                ]
              }
            ],
            askList: [{
              id: 1,
              type: 6,
              answerList: [],
              value: ['A. 脚踏车', 'B. 三轮车', 'C. 单车', 'D. 电动车']
            }]
          }, {
            id: 2,
            title: '(2)',
            durationTime: 100,
            steer: [
              {
                id: '2-1',
                imgModelSteer: true,
                imgbgModelSteer: true,
                buttonStyle: {
                  width: '40%',
                  float: 'left',
                  algin: 'right',
                  top: '-30px'
                },
                leftText: {
                  style: {
                    // top: '6.5%',
                    // left: '16%',
                    width: '40%',
                    // algin: 'left'
                  },
                  value: [
                    { text: '1、点击图片中右下角的“放大”观看大图，观看结束后再次点击“缩小”返回。' }
                  ]
                },
                leftbg: require('@/assets/exam/kuang_down.png'),
                bg: [
                  // {
                  //   img: require('@/assets/exam/kuang_down.png'),
                  //   style: {
                  //     top: '15.5%',
                  //     left: '16%',
                  //     width: '27%',
                  //     height: '47%'
                  //   }
                  // },
                  // {
                  //   img: require('@/assets/exam/button_kuang.png'),
                  //   style: {
                  //     top: '57.5%',
                  //     left: '35.5%',
                  //     width: '65px',
                  //     // height: '40px'
                  //   }
                  // }
                ],
              },
              {
                id: '2-2',
                rightModelSteer: true,
                rightbg: require('@/assets/exam/kuang_down.png'),
                buttonStyle: {
                  width: '30%',
                  float: 'right',
                  algin: 'center',
                  top: '-50px'
                },
                leftText: {
                  style: {
                    // top: '4%',
                    left: '73%',
                    width: '27%',
                    algin: 'left'
                  },
                  value: [
                    { text: '2.在作答区使用键盘输入以下文字：', },
                    { text: '“', },
                    { colorText: '避免拥堵，节约时间', color: '#BF95FF' },
                    { text: '”', }
                  ]
                },
                // bg: [
                //   {
                //     img: require('@/assets/exam/kuang_down.png'),
                //     style: {
                //       top: '23.5%',
                //       left: '55%',
                //       width: '45%',
                //       height: '390px'
                //     }
                //   }
                // ],
              },
              {
                id: '2-3',
                rightModelSteer: true,
                imgbgModelSteer: true,
                rightbg: require('@/assets/exam/kuang_down.png'),
                buttonStyle: {
                  width: '38%',
                  float: 'right',
                  algin: 'left',
                  top: '-40px'
                },
                leftText: {
                  style: {
                    // top: '3%',
                    left: '48%',
                    width: '52%',
                    algin: 'left'
                  },
                  value: [
                    { text: '3、点击“开始录音”按钮后按住，同时说出你对这个问题的答案，' },
                    { text: '说完后松开按钮。你说出的答案已经显示在作答区，' },
                    {
                      color: '#BF95FF',
                      fontSize: '18px',
                      colorText: '语音转录的正确吗？如果不正确，你可以点击文字，使用键盘进行修改。',
                    },
                  ]
                }
              }
            ],
            desc: [
              '2.观察资料二中的图片，请说出一项使用自行车作为交通工具的优点，并说明理由。',
              '在作答区使用键盘输入以下文字：“避免拥堵，节约时间”；',
              '点击“开始录音”按钮后按住，同时说出你对这个问题的答案（“因为自行车可以走非机动车道”），说完后松开按钮。你说出的答案已经显示在作答区，语音转录的正确吗？如果不正确，你可以点击文字，使用键盘进行修改。'
            ],
            stemContent: [
              {
                type: 'textArray',
                label: '资料二',
                value: [
                  { text: '这个练习是让你熟悉“放大观察图片”和“录入答案”功能。' },
                  { text: '点击图片中右下角的“放大”观看大图，观看结束后再次点击“缩小”返回。' },
                  { img: require('@/assets/exam/45.png') }
                ]
              }
            ],
            askList: [{
              id: 1,
              type: 1,
              isReview: true,
            }]
          }
        ]
      }, {
        qid: 2,
        title: '练习2',
        small: [
          {
            id: 3,
            title: '(3)',
            durationTime: 100,
            showAnswer: false,
            steer: [
              {
                id: '3-1',
                videoModelSteer: true,
                leftbg: require('@/assets/exam/kuang_down.png'),
                buttonStyle: {
                  width: '62%',
                  float: 'left',
                  algin: 'center',
                  top: '-50px'
                },
                leftText: {
                  style: {
                    // top: '5%',
                    left: '16%',
                    width: '30%',
                    algin: 'left'
                  },
                  value: [
                    { text: '1、点击视频播放按钮，观看和收听视频内容，期间可以在任意位置暂停或回放，视频完整播放一遍后，才可以答题。' }
                  ]
                },
                bg: [
                  // {
                  //   img: require('@/assets/exam/kuang_down.png'),
                  //   style: {
                  //     top: '24.5%',
                  //     left: '6.5%',
                  //     width: '46%',
                  //     height: '54%'
                  //   }
                  // },
                ],
              },
              {
                id: '3-2',
                rightModelSteer: true,
                // rightbgType: 'up',
                rightbg: require('@/assets/exam/kuang_down.png'),
                buttonStyle: {
                  width: '52%',
                  float: 'right',
                  algin: 'right',
                  top: '-40px'
                },
                leftText: {
                  style: {
                    // top: '36%',
                    left: '48%',
                    width: '50%',
                    algin: 'left'
                  },
                  value: [
                    { text: '2、答案将自动出现在下面的答题框内，请使用键盘对文字进行编辑和修改。当题目要求修改时，这个功能才会出现。', }
                  ]
                },
                bg: [
                  // {
                  //   img: require('@/assets/exam/kuang_up_left_chang.png'),
                  //   style: {
                  //     top: '28.5%',
                  //     left: '55%',
                  //     width: '45%',
                  //   }
                  // }
                ],
              },
              {
                id: '3-3',
                subModelSteer: true,
                rightModelSteer: true,
                rightbg: require('@/assets/exam/kuang_down.png'),
                buttonStyle: {
                  width: '52%',
                  float: 'right',
                  algin: 'right',
                  top: '-40px'
                },
                leftText: {
                  style: {
                    // top: '35%',
                    left: '52%',
                    width: '45%',
                    algin: 'left'
                  },
                  value: [
                    { text: '点击左边栏对应小题号，即可查看相应的资料。在练习过程中，你可以随时回看资料，但不可以返回修改题目。' }
                  ]
                },
                bg: [
                  // {
                  //   img: require('@/assets/exam/kuang_up_left_chang.png'),
                  //   style: {
                  //     top: '28.5%',
                  //     left: '55%',
                  //     width: '45%',
                  //     // height: '390px'
                  //   }
                  // },
                ],
              }
            ],
            desc: [
              '3.请观看资料三中的视频《自行车演化史》后回答，随着自行车未来的发展，你认为它还将具有怎样的优点？请你对第2题的回答进行修改或补充。',
              '你在上一题的答案已出现在下面的答题框内，请使用键盘对文字进行编辑和修改（输入“锻炼身体”）。当题目要求修改时，这个功能才会出现。'
            ],
            stemContent: [
              {
                type: 'textArray',
                label: '资料三',
                value: [
                  { text: '视频：自行车演化史' },
                  { text: '这个练习是让你熟悉“观看视频”和“修改上一题答案”功能。' },
                  { text: '点击视频播放按钮，观看和收听视频内容，其间可以在任意位置暂停或回放，视频完整播放一遍后，才可以答题。' },
                  {
                    type: 'video',
                    value: [
                      {
                        isControl: true,
                        autoPlay: false,
                        isloop: false,
                        url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/criticism_2_1.mp4'
                      }
                    ]
                  }
                ]
              }
            ],
            askList: [{
              id: 1,
              type: 1,
              richText: true
            }]
          },
          {
            id: 4,
            title: '(4)',
            durationTime: 100,
            desc: ['4.截止至2019年，自行车社会保有量位居世界第一的国家是', '本题正确答案是A。选择完成后，这个任务将结束。'],
            stemContent: [
              {
                type: 'textArray',
                value: [
                  { text: '这个练习是让你熟悉“回看资料”功能，具体的操作是：' },
                  { text: '点击左边栏对应小题号，即可查看相应的资料。在练习过程中，你可以随时回看资料，但不可以返回修改题目。' },
                  { text: '请回到第1题中再次读资料一，回答作答区域问题。' },
                ]
              }
            ],
            askList: [{
              id: 1,
              type: 5,
              value: [
                {
                  type: 'text',
                  val: 'A. 中国'
                },
                {
                  type: 'text',
                  val: 'B. 印度'
                },
                {
                  type: 'text',
                  val: 'C. 美国'
                }]
            }]
          },
        ]
      }],
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const examArr = JSON.parse(sessionStorage.currentExamGroup || '[]').exam || []
      const isEnd = type === 'overTime' || (examArr.length === 1 && currentQSmall === 4) // 超时或者只有一个试卷的最后一题，结束考试
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 12,
        subject_name: '批判引导',
        pic_info: '答案',
        status: isEnd ? 1 : 2
      }, sonData)
      const res = await answerUpload(data)
      this.loading = false
      if (!res || res.code != '200') {
        this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
        return
      }
      if (type === 'overTime' || currentQSmall === 4) {
        this.nextPage(isEnd)
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'criticismSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: sessionStorage.subjectName,
              isEnd: true
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
      // }, 1000);
    }
  },
  mounted() {
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
